/*!
 * @jimdo/angular-fontselect-typesquare v0.0.0
 * https://github.com/Jimdo/angular-fontselect-typesquare
 *
 * TypeSquare Plugin for Angular Fontselect
 *
 * Copyright 2017, Jimdo GmbH
 * Released under the MIT license
 */
(function(jQuery, window) { jQuery(function($) {
  'use strict';

  // src/js/helper.frontend-jq.js
  /** @const */
  var TYPESQUARE_INDICATOR = 'typesquare';
  
  var scriptUrl = false;
  var typesquareChars = {};
  var typesquareFonts = [];
  var $fontStyleTag = [];
  var _getTsFromAngular;
  var cacheTsPromise = false;
  
  /**
   * Reduce a string to the used characters.
   * @param  {String} source
   * @return {String}
   */
  function _reduce(source) {
    var arr = source.split('');
    var result = '';
    var character = null;
    for (var i = 0, l = arr.length; i < l; i++) {
      character = source[i];
      if (result.indexOf(character) < 0) {
        result += character;
      }
    }
    return result;
  }
  
  /**
   * Travers over all DOM elements and get those that are using a typesquare font
   * Then save this font and the characters used inside that element.
   * @return {Number} amount of fonts we've found.
   */
  function _findTypeSquareFonts() {
    typesquareFonts = [];
    typesquareChars = {};
  
    $('body *').each(function() {
      var $elm = $(this);
      var family = $elm.css('font-family');
  
      if (typeof family !== 'string') {
        return;
      }
  
      if (family.indexOf(TYPESQUARE_INDICATOR) >= 0) {
        if (typesquareFonts.indexOf(family) < 0) {
          typesquareChars[family] = '';
          typesquareFonts.push(family);
        }
        var text = '';
        switch ($elm.prop('tagName')) {
          case 'INPUT':
            text = $elm.val();
            break;
          case 'MENUITEM':
            text = $elm.prop('label');
            break;
          default:
            text = $elm.text();
        }
        if (text.length > 0) {
          typesquareChars[family] = _reduce(
              text.toUpperCase() + text.toLowerCase() + typesquareChars[family]
          ).replace(/\s+/g, '');
        }
      }
    });
  
    $.each(typesquareChars, function (fontFamily, text) {
      if (text.length === 0) {
        delete typesquareChars[fontFamily];
        typesquareFonts.splice(typesquareFonts.indexOf(fontFamily), 1);
      }
    });
  
    return typesquareFonts.length;
  }
  
  
  /**
   * Get an object, we can call dynamicCss on
   * @return {Object} promise, resolving to TypeSquare API or FontselectTypeSquare Service
   */
  function _getTs(irgnoreAngular) {
    var ivl = null;
    var d = $.Deferred();
    if (irgnoreAngular !== false && typeof angular !== 'undefined') {
      return _getTsFromAngular();
    } else if (!scriptUrl) {
      d.reject(new Error('Missing TypeSquare API Url.'));
    } else {
      $('head').append($('<script>').attr({
        src: scriptUrl,
        type: 'text/javascript'
      }));
  
      ivl = window.setInterval(function() {
        if (typeof window.Ts === 'object') {
          window.clearInterval(ivl);
          d.resolve(window.Ts);
        }
      }, 50);
    }
  
    return d;
  }
  
  /**
   * Cache the result of _getTs()
   * @return {Object} promise
   */
  function _getCachedTs() {
    if (!cacheTsPromise || cacheTsPromise.state() === 'rejected') {
      cacheTsPromise = _getTs();
    }
    return cacheTsPromise;
  }
  
  /**
   * Split a string by commas and return the first token with trimmed whitespace and quotation marks
   * @param  {String} stack
   * @return {String}
   */
  function _getFirstOfStack(stack) {
    return stack.split(',')[0].replace(/^[\s"']+|[\s"']+$/g, '');
  }
  
  /**
   * Since we have angular - try to get the service, so we do not need to
   * load the API multiple times.
   * Gracefully falls back to _getTs()
   * @return {Object} promise
   */
  _getTsFromAngular = function() {
    try {
      var d = $.Deferred();
      var service = angular.element(document).injector().get('jdFontselectTypesquareService');
      return d.resolve(service);
    } catch (e) {
      return _getTs(false);
    }
  };
  
  /**
   * Get a style tag we can add some fonts to, or generate a new one.
   * @return {Object} jQuery Element
   */
  function _getFontStyleTag() {
    if (!$fontStyleTag.length) {
      $fontStyleTag = $('<style>').attr({
        type: 'text/css',
        id: 'jd-fontselect-typesquare-fonts'
      });
      $('head').append($fontStyleTag);
    }
  
    return $fontStyleTag;
  }
  
  /**
   * Get all fonts from TypeSquare and put them to a style tag inside the header.
   * @param  {Object} Ts
   * @return {Object}    promise
   */
  function _loadAndApplyFonts(Ts) {
    var definitions = '';
    var $fontStyleTag = _getFontStyleTag();
    var d = $.Deferred();
    var i = 0;
  
    $.each(typesquareChars, function(stack, requiredChars) {
      var originalName, name = _getFirstOfStack(stack);
      function callback(result) {
        if (typeof result !== 'object' || !result.data || !/@font-face/.test(result.data)) {
          return d.reject(new Error('Invalid TypeSquare API response.'));
        }
  
        definitions += result.data;
  
        if (--i === 0) {
          $fontStyleTag.text(definitions);
          d.resolve();
        }
      }
      i++;
      originalName = window.name;
      Ts.dynamicCss(callback, requiredChars, name, name, '');
      window.name = originalName;
    });
  
    return d;
  }
  
  /**
   * See function name.
   * @param {String} url
   * @return {void}
   */
  function setScriptUrl(url) {
    scriptUrl = url;
  }
  
  /**
   * Search for used TypeSquare fonts, get the chars used in that font load, and apply it
   * @return {void}
   */
  function update(withScriptUrl) {
    if (typeof withScriptUrl === 'string') {
      setScriptUrl(withScriptUrl);
    }
  
    if (_findTypeSquareFonts()) {
      _getCachedTs().then(_loadAndApplyFonts);
    }
  }
  
  /* Expose */
  update.setScriptUrl = setScriptUrl;
  jQuery.angularFontselectUpdateTypesquare = update;
});})(window.jQuery, window);



/*****************
 ** WEBPACK FOOTER
 ** ./~/@jimdo/angular-fontselect-typesquare/dist/angular-fontselect-typesquare-frontend.js
 ** module id = 1517
 ** module chunks = 54 106 252
 **/